export default __webpack_public_path__ + "static/media/swipeGIS.b4747428.jpg";